import {Dropdown, ToolbarButton} from '@wordpress/components';
import {BlockEditProps} from '@wordpress/blocks';
import Section, {AllFields} from './widget-styles/Section';
import Settings from './widget-styles/Settings';
import {__} from '@wordpress/i18n';
import {CONFIG} from '../../globals/config';
import {select} from '@wordpress/data';

import styles from './widget-styles.pcss';


export type StyleOptions = {
	apply_current_page_styles_to_parent?: boolean;
	apply_current_page_parent_styles_to_parent?: boolean;
	block_style?: boolean;
	border?: boolean;
	border_color?: string;
	border_width?: number;
	bullet_style?: string;

	// Attributes automatically added by `supports.color` when registering the block.
	backgroundColor?: string;
	gradient?: string;
	style?: {
		color?: {
			background?: string;
			gradient?: string;
			text?: string;
			link?: string;
		}
	}
} & AllFields;

export type Props = Pick<BlockEditProps<StyleOptions>, 'attributes' | 'setAttributes'>;

const WidgetStyles = ( {attributes, setAttributes}: Props ) => {
	const post = select( 'core/editor' )?.getCurrentPost() ?? null;

	return (
		<Dropdown
			contentClassName={styles.dropdown}
			renderToggle={( {isOpen, onToggle} ) => <ToolbarButton
				title={__( 'Menu Styles', 'advanced-sidebar-menu' )}
				onClick={onToggle}
				icon={'admin-appearance'}
				isActive={isOpen}
			/>}
			renderContent={() => ( <div className={styles.wrap}>
				<div className={styles.column}>
					<Settings attributes={attributes} setAttributes={setAttributes} />
					{CONFIG.styles.sections.slice( 0, 2 ).map( section => <Section
						key={section.prefix}
						attributes={attributes}
						post={post}
						setAttributes={setAttributes}
						section={section} /> )}
				</div>
				<div className={styles.column}>
					{CONFIG.styles.sections.slice( 2 ).map( section => <Section
						key={section.prefix}
						attributes={attributes}
						post={post}
						setAttributes={setAttributes}
						section={section} /> )}
				</div>
				<div className={styles.clear} />
			</div> )}
		/>
	);
};

export default WidgetStyles;
